module.exports = __webpack_public_path__ + "img/baleno.ffb8a7c2.png";